import React from 'react'
import {useState, useContext, useEffect} from 'react'
import {useQuery} from 'react-query'
import {FeedbackContext} from '../../../../Components/Context/FeedbackContext'
import {Loading} from '../../../../Components/Loading/Loading'
import {ErrorConnection} from '../../../../Components/Error/Error'
import {Spinner} from 'react-bootstrap'
import * as Api from '../../../../api/Api'
import {useGetToken} from '../../../../Hooks/CustomHooks'
import * as Utilities from '../../../../Components/Utils/Utils'
import $ from 'jquery'
import {Helmet} from 'react-helmet'
import '../mapplic.css'
import {BlockPicker} from 'react-color'
import Modal from 'react-bootstrap/Modal'

function Vacancy({unidadEconomica, setVacancyData}) {
  const [mapplicObj, setMapplicObj] = useState(null)
  const token = useGetToken()
  const [smShow, setSmShow] = useState(false)
  const [objetoChangeStatus, setObjetoChangeStatus] = useState({
    id: null,
    nombre: null,
    status: null,
  })
  const [currentNewStatus, setCurrentNewStatus] = useState(null)

  const colorStatus1 = '#87c141'
  const colorStatus2 = '#434df4'
  const colorStatus3 = '#f4e21a'
  const colorStatus4 = '#e74157'

  const getColorStatusByStatus = (idStatus) => {
    let colorStatus = ''
    switch (idStatus) {
      case '1':
        colorStatus = colorStatus1
        break
      case '2':
        colorStatus = colorStatus2
        break
      case '3':
        colorStatus = colorStatus3
        break
      case '4':
        colorStatus = colorStatus4
        break
    }
    return colorStatus
  }

  const getIdStatusByColorHex = (colorHex) => {
    let idStatus = ''
    switch (colorHex) {
      case colorStatus1:
        idStatus = '1'
        break
      case colorStatus2:
        idStatus = '2'
        break
      case colorStatus3:
        idStatus = '3'
        break
      case colorStatus4:
        idStatus = '4'
        break
    }
    return idStatus
  }

  const getnameStatusByColor = (colorHex) => {
    let nameStatus = ''

    switch (colorHex) {
      case colorStatus1:
        nameStatus = 'Operando'
        break
      case colorStatus2:
        nameStatus = 'Obra'
        break
      case colorStatus3:
        nameStatus = 'Firmado'
        break
      case colorStatus4:
        nameStatus = 'Vacancy'
        break
    }
    return nameStatus
  }

  const getnameStatusByStatusId = (idStatus) => {
    let nameStatus = ''
    // console.log(idStatus);
    switch (idStatus) {
      case '1':
        nameStatus = 'Operando'
        break
      case '2':
        nameStatus = 'Obra'
        break
      case '3':
        nameStatus = 'Firmado'
        break
      case '4':
        nameStatus = 'Vacancy'
        break
    }
    //console.log(nameStatus);
    return nameStatus
  }

  const [colorPicked, setColorPicked] = useState({
    hex: getColorStatusByStatus(objetoChangeStatus.status),
    idStatus: objetoChangeStatus.status,
    statusName: getnameStatusByStatusId(objetoChangeStatus.status),
  })

  let handleChangeColorPick = (color) => {
    setColorPicked({
      hex: color.hex,
      idStatus: getIdStatusByColorHex(color.hex),
      statusName: getnameStatusByColor(color.hex),
    })
  }

  let handleChangeStatusToObjeto = () => {
    setCurrentNewStatus({
      idObjeto: objetoChangeStatus.id,
      idNewstatus: colorPicked.idStatus,
    })
    setSmShow(false)
  }

  const {feedbackContext, setFeedbackContext} = useContext(FeedbackContext)
  let {data, isLoading, isError, error, isFetching} = useQuery(
    [
      'MapaCalorVacancy',
      {
        unidadEconomica: unidadEconomica.value,
      },
    ],
    async () =>
      await Api.MapaCalorVacancyList({
        unidadEconomicaId: unidadEconomica.value,
        token: token /*data: data?.data*/,
      }),
    {
      enabled: true,
    }
  )

  let {
    data: dataChangeStatus,
    isLoading: isLoadingChangeStatus,
    isErrorChangeStatus,
    errorChangeStatus,
    isFetchingChangeStatus,
  } = useQuery(
    [
      'MapaCalorVacancyChangeStatus',
      {
        unidadEconomicaId: unidadEconomica.value,
        idObjeto: currentNewStatus?.idObjeto,
        idNewStatus: currentNewStatus?.idNewstatus,
      },
    ],
    async () =>
      await Api.MapaCalorVacancyChangeStatus({
        unidadEconomicaId: unidadEconomica.value,
        idObj: currentNewStatus.idObjeto,
        idNewStatus: currentNewStatus.idNewstatus,
        token: token /*data: data?.data*/,
      }),
    {
      enabled: currentNewStatus != null,
    }
  )

  useEffect(() => {
    if (data) {
      if (data.data === null) {
        setFeedbackContext({...feedbackContext, showError: true, idError: data.errorId})
      } else {
        setJsonMapFinalwithSettings(data.data.mapaCalor)
        setVacancyData(data.data.vacancyData)
      }
    }
    if (dataChangeStatus) {
      // console.log(dataChangeStatus);
      if (dataChangeStatus.success == false) {
        setFeedbackContext({
          ...feedbackContext,
          showError: true,
          isErrorChangeStatus: dataChangeStatus.errorId,
        })
      } else {
        // console.log(dataChangeStatus.success);
        window.location.reload()
      }
    }
  }, [data, dataChangeStatus])

  function setJsonMapFinalwithSettings(jsonResponseFromServer) {
    const settings = {
      mapwidth: '1300',
      mapheight: '1000',
      defaultstyle: 'normal',
      styles: [
        {
          class: 'statusClass1',
          base: {
            fill: colorStatus1,
            'fill-opacity': '0.4',
          },
          hover: {
            'fill-opacity': '0.8',
          },
          active: {
            fill: 'green',
            'fill-opacity': '1',
          },
        },
        {
          class: 'statusClass2',
          base: {
            fill: colorStatus2,
            'fill-opacity': '0.4',
          },
          hover: {
            'fill-opacity': '0.8',
          },
          active: {
            fill: 'yellow',
            'fill-opacity': '1',
          },
        },
        {
          class: 'statusClass3',
          base: {
            fill: colorStatus3,
            'fill-opacity': '0.4',
          },
          hover: {
            'fill-opacity': '0.8',
          },
          active: {
            fill: 'blue',
            'fill-opacity': '1',
          },
        },
        {
          class: 'statusClass4',
          base: {
            fill: colorStatus4,
            'fill-opacity': '0.4',
          },
          hover: {
            'fill-opacity': '0.8',
          },
          active: {
            fill: 'red',
            'fill-opacity': '1',
          },
        },
      ],
      groups: [
        {
          id: 'statusCategory1',
          title: 'Operando',
          color: colorStatus1,
          legend: 'true',
          style: 'statusClass1',
        },
        {
          id: 'statusCategory2',
          title: 'Obra',
          color: colorStatus2,
          legend: 'true',
          style: 'statusClass2',
        },
        {
          id: 'statusCategory3',
          title: 'Firmado',
          color: colorStatus3,
          legend: 'true',
          style: 'statusClass3',
        },
        {
          id: 'statusCategory4',
          title: 'Vacancy',
          color: colorStatus4,
          legend: 'true',
          style: 'statusClass4',
        },
      ],
    }

    let data = jsonResponseFromServer

    data.levels.forEach(function (element, index1, array) {
      if (parseInt(element.id) < 0) element['title'] = 'Sótano ' + Math.abs(parseInt(element.id))
      element['map'] =
        '/../mapas/' +
        unidadEconomica.label.toLowerCase().replace(/\s/g, '') +
        '/piso_' +
        element.id +
        '.svg'

      element.locations.forEach(function (elementLocation, index2, array) {
        elementLocation['pin'] = 'hidden'
        elementLocation['titleModal'] = elementLocation['title']
        elementLocation['category'] = 'statusCategory' + elementLocation.estado
        elementLocation['style'] = 'statusCategory' + elementLocation.estado
        elementLocation['title'] =
          elementLocation['title'].length > 15
            ? elementLocation['title'].slice(0, 15) + '...'
            : elementLocation['title']
        elementLocation['description'] = `<span ></span>`
      })
    })

    let returnedTarget = Object.assign(data, settings)

    let mapplicObjTemp = {
      source: returnedTarget,
      height: 'auto',
      // minimap: true,
      lightbox: true,
      sidebar: false,
      hovertip: true,
      maxscale: 10,
      developer: false,
      highlight: true,
      zoom: true,
      mousewheel: true,
      closezoomout: true,
      thumbholder: true,
    }

    let encontrados = 0
    let locationNull = false
    function setColorLocatarios() {
      for (let indexLevel = 0; indexLevel < data.levels.length; indexLevel++) {
        if (locationNull && encontrados < 3) break
        const element = data.levels[indexLevel]
        for (let indexLocation = 0; indexLocation < element.locations.length; indexLocation++) {
          if (locationNull && encontrados < 3) break
          const elementLocation = element.locations[indexLocation]

          locationNull = $('#' + elementLocation.id).length == 0
          if (!locationNull) encontrados++
          else console.log(elementLocation.id, $('#' + elementLocation.id).length)

          let colorHex =
            elementLocation.estado == '1'
              ? 'colorStatus1'
              : elementLocation.estado == '2'
              ? 'colorStatus2'
              : elementLocation.estado == '3'
              ? 'colorStatus3'
              : elementLocation.estado == '4'
              ? 'colorStatus4'
              : 'colorDefault'

          $('#' + elementLocation.id).attr('class', colorHex)
          $('#' + elementLocation.id).attr('data-toggle', 'tooltip')
          $('#' + elementLocation.id).attr('data-placement', 'Tooltip on top')
          $('#' + elementLocation.id).attr('data-bs-html', 'true')
          $('#' + elementLocation.id).attr(
            'title',
            elementLocation.id + ' : ' + elementLocation.titleModal
          )

          $('#' + elementLocation.id).on('click touchstart', function () {
            setObjetoChangeStatus({
              id: elementLocation.id,
              nombre: elementLocation.titleModal,
              status: elementLocation.estado,
            })
            setColorPicked({
              idStatus: elementLocation.estado,
              hex: getColorStatusByStatus(elementLocation.estado),
              statusName: getnameStatusByStatusId(elementLocation.estado),
            })

            setSmShow(true)
            $('input').last().parent().remove()
            if ($('.block-picker div').length == 10) {
              $('.block-picker div').first().remove()
            }
            $('.block-picker div').first().children().remove()
          })
        }
      }
      if (locationNull)
        setTimeout(function () {
          locationNull = false
          setColorLocatarios()
        }, 1500)
    }

    setTimeout(function () {
      setColorLocatarios()
    }, 1500)

    //#endregion

    setMapplicObj(mapplicObjTemp)
  }

  if (isLoadingChangeStatus) return <Loading />
  if (isLoading) return <Loading />
  if (isError) return <ErrorConnection error={error} />
  return (
    <>
      {isFetching ? (
        <Spinner animation='grow' variant='secondary' />
      ) : data?.data && data?.data?.mapaCalor?.levels.length > 0 ? (
        <>
          <div className='application'>
            <Helmet>
              <script>
                {`
                                        if (` +
                  JSON.stringify(mapplicObj) +
                  ` != null) {
                                            $('#mapplic_container_vacancy').mapplic(` +
                  JSON.stringify(mapplicObj) +
                  `);
                                            setTimeout(function () {
                                                $('[data-toggle="tooltip"]').tooltip({ container: 'body' })
                                            }, 2000)
                                        }
                                    `}
              </script>
            </Helmet>
          </div>

          <Modal
            show={smShow}
            aria-labelledby='contained-modal-title-vcenter'
            centered
            onHide={() => setSmShow(false)}
          >
            <Modal.Header className='header-personalizable' closeButton>
              <Modal.Title id='contained-modal-title-vcenter'>
                <div className='d-flex justify-content-center modal-title h4'>
                  <div className='d-flex align-items-center   me-5 '>
                    <span className='svg-icon svg-icon-4 me-1'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <path
                          opacity='0.3'
                          d='M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z'
                          fill='black'
                        ></path>
                        <path
                          d='M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z'
                          fill='black'
                        ></path>
                      </svg>
                    </span>
                    Locatario: {objetoChangeStatus.id} : {objetoChangeStatus.nombre}
                  </div>
                  <div className='d-flex align-items-center '>
                    <span className='svg-icon svg-icon-4 me-1'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <path
                          opacity='0.3'
                          d='M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z'
                          fill='black'
                        ></path>
                        <path
                          d='M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z'
                          fill='black'
                        ></path>
                      </svg>
                    </span>
                    Estado: {colorPicked.statusName}
                  </div>
                </div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <BlockPicker
                color={colorPicked.hex}
                colors={[colorStatus1, colorStatus2, colorStatus3, colorStatus4]}
                triangle='hide'
                onChange={handleChangeColorPick}
              ></BlockPicker>
            </Modal.Body>
            <Modal.Footer>
              <button className='btn btn-secondary' onClick={() => setSmShow(false)}>
                Cerrar
              </button>
              <button className='btn btn-primary' onClick={() => handleChangeStatusToObjeto()}>
                Cambiar
              </button>
            </Modal.Footer>
          </Modal>

          <div id='mapplic_container_vacancy'></div>
        </>
      ) : (
        <div class='alert alert-warning' role='alert'>
          Actualmente no existen datos para este Mall.
        </div>
      )}
    </>
  )
}

export default Vacancy
